import { render, staticRenderFns } from "./BlockType17.vue?vue&type=template&id=3144c6a8&scoped=true"
import script from "./BlockType17.vue?vue&type=script&lang=ts"
export * from "./BlockType17.vue?vue&type=script&lang=ts"
import style0 from "./BlockType17.vue?vue&type=style&index=0&id=3144c6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3144c6a8",
  null
  
)

export default component.exports